import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

let eventBus = globalEventBus('user controls')


addEventListener()


let api

eventBus.on('world api loaded', function (_api) {
    api = _api
})

eventBus.on('world unloaded', function () {
    api = null
})


function addEventListener () {

    let start
    let minSwipeDistance = 40

    $(document).on('touchstart', function (e) {
        start = {
            x: e.originalEvent.touches[0].pageX,
            y: e.originalEvent.touches[0].pageY
        }
    })

    $(document).on('touchmove', function (e) { //eslint-disable-line complexity
        if (!api) {
            return
        }
        e.preventDefault()
        if (!start) {
            return
        }
        let end = {
            x: e.originalEvent.touches[0].pageX,
            y: e.originalEvent.touches[0].pageY
        }
        let deltaX = end.x - start.x
        let deltaY = end.y - start.y
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < minSwipeDistance) {
            return
        }
        start = null

        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > 0) {
                api.right()
            } else {
                api.left()
            }
        } else {
            if (deltaY > 0) {
                api.down()
            } else {
                api.up()
            }
        }
    })

}

